import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CourseFeedbackListComponent } from './course-feedback-list/course-feedback-list.component';
import { CourseFeedbackViewComponent } from './course-feedback-view/course-feedback-view.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'list-page',
        component: CourseFeedbackListComponent,
        data: {
          title: "List Page",
          breadcrumb: "List Page"
        }
      },
      /* {
        path: 'view-page',
        component: CourseFeedbackViewComponent,
        data: {
          title: "View Page",
          breadcrumb: "View Page"
        }
      }, */
      {
        path: 'course-feedback-view/:id',
        component: CourseFeedbackViewComponent,
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CourseFeedbackRoutingModule { }
